module.exports = __webpack_public_path__ + "static/img/bjft.1e71622.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/participationCenter/bjft.png
// module id = MvLg
// module chunks = 0